import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';
import {
  PackageMappingListFilters,
  PackageMappingRow,
  PackageMappingsPayload,
} from '../models/package-mapping.model';

/** Filters used by Super Admin Way package mapping (wash packages only). */
export const WASH_PACKAGE_MAPPING_FILTERS: PackageMappingListFilters = {
  type: 'car_wash',
  wash_types: ['single_wash', 'monthly_membership'],
};

@Injectable({
  providedIn: 'root',
})
export class PackageMappingService {
  private readonly apiService = inject(ApiService);

  private packageMappingsPath(companyId: string, locationId: string): string {
    return `admin/super-admin/companies/${companyId}/locations/${locationId}/package-mappings`;
  }

  listPackageMappings(
    companyId: string,
    locationId: string,
    filters: PackageMappingListFilters = WASH_PACKAGE_MAPPING_FILTERS
  ): Observable<ApiResponse<PackageMappingRow[]>> {
    const params: Record<string, string> = {};
    if (filters.type) {
      params['type'] = filters.type;
    }
    if (filters.wash_types?.length) {
      params['wash_types'] = filters.wash_types.join(',');
    }

    return this.apiService
      .getWithSuperAdminToken<PackageMappingRow[]>(
        this.packageMappingsPath(companyId, locationId),
        params
      )
      .pipe(catchError(error => throwError(() => error)));
  }

  updatePackageMappings(
    companyId: string,
    locationId: string,
    payload: PackageMappingsPayload
  ): Observable<ApiResponse<PackageMappingRow[]>> {
    return this.apiService
      .putWithSuperAdminToken<PackageMappingRow[]>(
        this.packageMappingsPath(companyId, locationId),
        payload
      )
      .pipe(catchError(error => throwError(() => error)));
  }
}
